import type { IProfileOption, ICreateUserPayload, IUpdateUserPayload } from "../types";

export const buildProfileSelectOptions = (
  profiles: IProfileOption[],
  type: "user_profile" | "banking_profile",
) => {
  return profiles?.reduce<{ label: string; value: string }[]>((acc, profile) => {
    if (profile?.type === type) {
      acc.push({
        label: profile?.label || "",
        value: String(profile?.value || ""),
      });
    }
    return acc;
  }, []);
};

export const buildCreatePayload = (
  email: string,
  acquiringProfile: string,
  bankingProfile: string,
): ICreateUserPayload => ({
  email,
  profile: acquiringProfile || null,
  bankingProfile: bankingProfile || null,
});

export const buildUpdatePayload = (
  acquiringProfile: string,
  bankingProfile: string,
  status: string,
): IUpdateUserPayload => ({
  profile: acquiringProfile || null,
  bankingProfile: bankingProfile || null,
  status,
});
